module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="share-list-intro">\n    <h3>Sharing options</h3>\n    <p>\n        Please choose which informations should be\n        revealed when sharing this set.\n    </p>\n</div>\n\n<ol class="table-columns"></ol>\n';
}
return __p;
};